import React from 'react';
import ComplexGame from './components/complex_game';

require('./resources/styles/styles');

function App() {
	return <ComplexGame />;
}

export default App;
